import dayjs from "dayjs";
import { TextInput } from "@normasteaching/norma-ui";
import { WithdrawalRequestDTO } from "./WithdrawalRequestDTO.ts";

type Props = {
  date: string;
  onChange: (date: string) => void;
  existingRequest: WithdrawalRequestDTO | null;
  hasWithdrawablePurchase: boolean;
  loading: boolean;
  disabled?: boolean;
};

export function WithdrawalRequestDateField({
  date,
  onChange,
  existingRequest,
  hasWithdrawablePurchase,
  loading,
  disabled,
}: Props) {
  return (
    <div className="flex flex-col gap-1">
      <label className="block text-sm font-medium text-gray-900">
        Data richiesta di rimborso
      </label>
      <TextInput
        type="date"
        value={date}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || loading}
      />
      {loading ? (
        <p className="text-xs text-gray-500">Cerco la richiesta di recesso…</p>
      ) : existingRequest ? (
        <p className="text-xs text-gray-500">
          Richiesta di recesso registrata il{" "}
          {dayjs(existingRequest.requestedAtUtc).format("DD/MM/YYYY")}.
          Modificando la data qui aggiorni anche la richiesta.
        </p>
      ) : hasWithdrawablePurchase ? (
        <p className="text-xs text-gray-500">
          Nessuna richiesta registrata: confermando il rimborso ne viene creata
          una con questa data.
        </p>
      ) : (
        <p className="text-xs text-gray-500">
          Nessun acquisto tracciabile per questo cliente: la data non verrà
          registrata.
        </p>
      )}
    </div>
  );
}
